import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';
import { MutateBulkRequestResponse } from '@app/store/transport-layer/bulk-request/bulk-requests';

export function postBulkRequestsTerminate(
  workspaceId: string,
  bulkRequestId: string
): Promise<MutateBulkRequestResponse> {
  return requestApi<MutateBulkRequestResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/terminate`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
